import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import clsx from 'clsx';
import { Text } from '../Text/Text';
import s from './TextButton.scss';
export const TextButton = _ref => {
  let {
    className,
    dataHook,
    children,
    onClick,
    underline,
    prefixIcon,
    suffixIcon,
    id,
    disabled,
    size,
    light,
    ellipsis,
    skin = 'standard',
    weight,
    disableClick,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("button", _extends({
    "data-hook": dataHook,
    id: id,
    disabled: disabled || disableClick,
    className: clsx(s.textButton, {
      [s.disabled]: disabled,
      [s.disableClick]: disableClick,
      [s.standard]: skin === 'standard',
      [s.shadow]: skin === 'shadow'
    }, className),
    onClick: onClick
  }, props), prefixIcon || null, /*#__PURE__*/React.createElement(Text, {
    className: clsx(s.text, {
      [s.underline]: underline === 'always',
      [s.underlineOnHover]: underline === 'onHover'
    }),
    size: size,
    light: light,
    weight: weight,
    ellipsis: ellipsis
  }, children), suffixIcon || null);
};
//# sourceMappingURL=TextButton.js.map